import { bdltAuthHeader } from '../helpers'
import { authService } from './authentication.service'

export const bdltService = {
    login,
    refreshToken,
    handleBDLTResponse,
    getVariablesData,
    getVariablesMetaData,
    writeNumericVariable,
    writeTextVariable
}

function login() {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            login: `${process.env.VUE_APP_API_BDLT_LOGIN}`,
            password: `${process.env.VUE_APP_API_BDLT_PWD}`,
            rememberMe: true
        })
    };

    return fetch(`${process.env.VUE_APP_API_BDLT_URL}/auth/authorize`, requestOptions)
        .then(handleBDLTResponse)
        .then(token => {
            if (token.accessToken) {
                localStorage.setItem('bdlttoken', JSON.stringify(token));
            }
            return token;
        })
        .catch(error => {
            //console.error('Erreur lors de la requête:', error);
        });

}


function refreshToken () {
    var bdltToken = localStorage.getItem('bdlttoken')
    if (bdltToken != null && bdltToken.accessToken != null)
    {
        const requestOptions = {
            method: 'POST',
            headers: bdltAuthHeader(),
            body: JSON.stringify({ token: JSON.parse(localStorage.getItem('bdlttoken')).accessToken })
        }

        return fetch(`${process.env.VUE_APP_API_BDLT_URL}/auth/refreshToken`, requestOptions)
            .then(this.handleBDLTResponse)
            .then(token => {
                if (token.accessToken) {
                    localStorage.setItem('bdlttoken', JSON.stringify(token))
                }

                return token
            })
    }
    else
    {
        login()
    }
}

async function getVariablesData (variableIds, start, stop) {
    const requestOptions = {
        method: 'GET',
        headers: bdltAuthHeader()
    }

    if (!Array.isArray(variableIds)) {
        variableIds = [variableIds]
    }
    if (!start) {
        start = '1901-01-01T00:00:00.000Z'
    }
    if (!stop) {
        stop = new Date().toJSON()
    }

    var dataToReturn = { series: [] }

    while (variableIds.length > 0) {
        var chunk = variableIds.splice(0, 10)

        dataToReturn = await fetch(`${process.env.VUE_APP_API_BDLT_URL}/data/q?ids=${chunk.join(',')}&start=${start}&stop=${stop}&fields=*&dataUnit=Display&extendedPeriod=false&aggregate=none`, requestOptions)
            .then(this.handleBDLTResponse)
            .then(data => {
                if (data && data.series && data.series.length > 0) {
                    dataToReturn.series = dataToReturn.series.concat(data.series)
                }

                return dataToReturn
            })
    }

    return dataToReturn
}

async function getVariablesMetaData (variablesIds) {
    const requestOptions = {
        method: 'GET',
        headers: bdltAuthHeader()
    }

    if (!Array.isArray(variablesIds)) {
        variablesIds = [variablesIds]
    }

    var dataToReturn = []

    while (variablesIds.length > 0) {
        var chunk = variablesIds.splice(0, 10)

        dataToReturn = await fetch(`${process.env.VUE_APP_API_BDLT_URL}/variables?variableIds=${chunk.join('&variableIds=')}`, requestOptions)
            .then(this.handleBDLTResponse)
            .then(data => {
                if (data && data.length > 0) {
                    dataToReturn = dataToReturn.concat(data)
                }

                return dataToReturn
            })
    }

    return dataToReturn
}

function writeNumericVariable (variables) {
    let payload = []

    if (!variables || variables.length === 0) {
        return
    }

    variables.forEach(v => {
        let measures = []

        if (!v.listeMesure || v.listeMesure.length === 0) {
            return
        }

        v.listeMesure.forEach(m => {
            measures.push({ timestamp: m.dateMesure, value: m.valeurMesure })
        })

        payload.push({ id: v.guidVariable, points: measures })
    })

    const requestOptions = {
        method: 'POST',
        headers: bdltAuthHeader(),
        body: JSON.stringify(payload)
    }

    return fetch(`${process.env.VUE_APP_API_BDLT_URL}/data/writeNumericValues`, requestOptions)
        .then(this.handleBDLTResponse)
        .then(data => {
            return data
        })
}

function writeTextVariable (variables) {
    let payload = []

    if (!variables || variables.length === 0) {
        return
    }

    variables.forEach(v => {
        let measures = []

        if (!v.listeMesure || v.listeMesure.length === 0) {
            return
        }

        v.listeMesure.forEach(m => {
            measures.push({ timestamp: m.dateMesure, value: m.valeurMesure })
        })

        payload.push({ id: v.guidVariable, points: measures })
    })

    const requestOptions = {
        method: 'POST',
        headers: bdltAuthHeader(),
        body: JSON.stringify(payload)
    }

    return fetch(`${process.env.VUE_APP_API_BDLT_URL}/data/writeTextValues`, requestOptions)
        .then(this.handleBDLTResponse)
        .then(data => {
            return data
        })
}

function handleBDLTResponse (response) {
    return response.text().then(text => {
        try {
            const data = text && JSON.parse(text)

            if (!response.ok) {
                if (response.status === 401) {
                    authService.logout()
                }

                const error = data

                return Promise.reject(error)
            }

            return data
        } catch (e) { return text }
    })
}
